export default __webpack_public_path__ + "static/media/SunWestLogo.36785b40.png";